import "bootstrap/dist/css/bootstrap.css";
import "./src/scss/global.scss";
// require("prismjs/themes/prism-okaidia.css");
